module.exports = __webpack_public_path__ + "img/source1_2.a70dc21b.png";